module.exports = __webpack_public_path__ + "img/Kingo_Salmedikteren_Thomas_Kingo.c4429eb9.jpg";